import { Card, CardContent, CardHeader, Chip, Divider, Grid, Link, Typography } from '@material-ui/core';
import { Progress } from '@backstage/core-components';
import { Alert } from '@material-ui/lab';
import { useUpwindResources } from './useUpwindResources';

const UPWIND_CONSOLE_URL = 'https://console.upwind.io';

export function EntityUpwindCard() {
  const { loading, error, value } = useUpwindResources();

  const resources = value?.resources ?? [];

  if (loading && !resources.length) {
    return (
      <Grid item md={6} xs={12}>
        <Card>
          <CardContent>
            <Progress />
          </CardContent>
        </Card>
      </Grid>
    );
  }

  if (error && !resources.length) {
    return (
      <Grid item md={6} xs={12}>
        <Card>
          <CardHeader title="Upwind Security" titleTypographyProps={{ variant: 'h6' }} />
          <Divider />
          <CardContent>
            <Alert severity="error">{error.message}</Alert>
          </CardContent>
        </Card>
      </Grid>
    );
  }

  if (resources.length === 0) return null;

  const criticalVulns = resources.reduce(
    (sum, r) => sum + (r.vulnerability_risk.critical_count ?? 0),
    0,
  );
  const criticalDetections = resources.reduce(
    (sum, r) => sum + (r.detection_risk.critical_count ?? 0),
    0,
  );
  const isExposed = resources.some(r => r.network_exposure_type !== 'none');

  return (
    <Grid item md={6} xs={12}>
      <Card>
        <CardHeader title="Upwind Security" titleTypographyProps={{ variant: 'h6' }} />
        <Divider />
        <CardContent>
          {error && <Alert severity="warning" style={{ marginBottom: 12 }}>{error.message}</Alert>}
          <Typography variant="body1" gutterBottom>
            <strong>{resources.length}</strong> resource{resources.length !== 1 ? 's' : ''} monitored
          </Typography>
          <Typography variant="body2" gutterBottom>
            Critical vulnerabilities:{' '}
            <Chip
              size="small"
              label={criticalVulns}
              color={criticalVulns > 0 ? 'secondary' : 'default'}
            />
          </Typography>
          <Typography variant="body2" gutterBottom>
            Critical detections:{' '}
            <Chip
              size="small"
              label={criticalDetections}
              color={criticalDetections > 0 ? 'secondary' : 'default'}
            />
          </Typography>
          <Typography variant="body2" gutterBottom>
            Network exposure:{' '}
            <Chip size="small" label={isExposed ? 'Exposed' : 'No exposure'} />
          </Typography>
          <Typography variant="body2" style={{ marginTop: 8 }}>
            <Link href={UPWIND_CONSOLE_URL} target="_blank" rel="noopener noreferrer">
              View in Upwind
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}
